export const requiredRule = {
  required: true,
  message: 'Обязательное поле'
}

export const xssRegEx = /(javascript:|<\s*script.*?\s*>)/;
